if (!customElements.get('cart-lens-accordion')) {
  class CartLensAccordion extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
    }

    connectedCallback() {
      this.setupAccordion();
    }

    setupAccordion() {
      const toggleButton = this.querySelector('.cart-lens-accordion__toggle');
      const content = this.querySelector('.cart-lens-accordion__content');

      if (!toggleButton || !content) return;

      toggleButton.addEventListener('click', event => {
        event.preventDefault();
        this.toggle();
      });
    }

    toggle() {
      this.isOpen = !this.isOpen;
      const content = this.querySelector('.cart-lens-accordion__content');
      const toggleButton = this.querySelector('.cart-lens-accordion__toggle');

      if (!content || !toggleButton) return;

      if (this.isOpen) {
        /** @type {HTMLElement} */ (content).style.maxHeight =
          content.scrollHeight + 'px';
        toggleButton.setAttribute('aria-expanded', 'true');
        this.classList.add('cart-lens-accordion--open');
      } else {
        /** @type {HTMLElement} */ (content).style.maxHeight = '0px';
        toggleButton.setAttribute('aria-expanded', 'false');
        this.classList.remove('cart-lens-accordion--open');
      }
    }
  }

  customElements.define('cart-lens-accordion', CartLensAccordion);
}
